import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import UploadImages from '../../Loteos/UploadImages.js';


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            imagenes: [],     
            sucursal_id: null,     
            postVariables: ['sucursal_id'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    resetForm() {
        this.setState({
            id: null,
            imagenes: [],
            sucursal_id: null,  
            errors: [],
        });
    }

    getData() {
        const { postVariables} = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });

        // Convertir las imagenes a solo la primera de UploadImages.js
        data.imagen =  this.state.imagenes[0].imagen

        return data;
    }

    setData(data) {
        if (data.success) {
            // Se transforma la imagen para que sea compatible con el
            // componente UploadImages.js
            const imagenes = data.imagen ? [{
                id: data.id,
                imagen: data.imagen
            }] : [];

            this.setState({
                id: data.id,
                imagenes,
                sucursal_id: data.sucursal ? data.sucursal.id : null,  
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nueva Firma",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "La Firma ha sido creada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Firma",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La Firma ha sido editada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Firma",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Firma",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "La Firma ha sido eliminada con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    render() {
        const {imagenes , sucursal_id} = this.state;
        let vars = this.modalVars();
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.recibos.firmas : null)}
                submitUrl={(vars.submitType ? api.recibos.firmas : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onClose={() => this.resetForm()}
                onSubmit={(e) => this.props.onSubmit(e)}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                className="ui-paradigma-modal"
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
                fileUploader
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Imagen de firma</p>
                    <UploadImages
                        disabled={vars.disabled}
                        imagenes={imagenes}
                        onChange={imagenes => this.setState({ imagenes })}
                    />
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Asignación</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            label={"Sucursal"}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    disabled={vars.disabled}
                                    url={api.geograficas.sucursales}
                                    parameters={{
                                        sort:['nombre'],
                                        paginationEnabled:false,
                                    }}
                                    value={sucursal_id}
                                    onChange={(data) => this.onChangeField('sucursal_id', (data ? data.id : null))}
                                />
                            }
                            error={() => this.getError('sucursal_id')}
                        />
                    </div>
                </section>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Recibos/Firmas/Modal.js